import { getShopTemplate } from "./shopRegistry";
import { siteTemplateRendererCode } from "./templateRendererCode";
import type { TemplateRenderProps } from "./types";

export function ShopTemplateRenderer(props: TemplateRenderProps) {
    const template = getShopTemplate(siteTemplateRendererCode(props.site));

    return template.render({
        ...props,
        designOverride: props.designOverride ?? props.site?.templateDesign ?? null,
    });
}
